export default __webpack_public_path__ + "static/2-newuser-4a3350de9a1d6bd47b212a49a3977344.jpg";